import './password-input.css';
import { Input } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import classNames from 'classnames';
import React, { useState } from 'react';
export const PasswordInput = ({ invalidData, value, handleChangePassword }) => {
    const [showPassword, setShowPassword] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(InputLabel, { className: classNames({
                'input_error-label': invalidData || value === null
            }), htmlFor: "standard-adornment-password", shrink: true }),
        React.createElement(Input, { className: "u-margin-bottom-medium", endAdornment: React.createElement(InputAdornment, { className: "icon-btn_password", position: "end" },
                React.createElement(IconButton, { "aria-label": "toggle password visibility", onClick: () => {
                        setShowPassword((prevShowPassword) => !prevShowPassword);
                    } }, showPassword ? React.createElement(Visibility, null) : React.createElement(VisibilityOff, null))), error: invalidData || value === null, fullWidth: true, id: "standard-adornment-password", onChange: handleChangePassword, placeholder: "Password", type: showPassword ? 'text' : 'password', value: value }),
        React.createElement("span", { className: "input_error-msg" }, value === null ? 'Invalid password' : '')));
};
